let r = null, t = !1;
function d(o, n) {
  return r || (r = new Promise((i, c) => {
    const e = document.createElement("script");
    e.src = `//players.brightcove.net/${o}/${n}_default/index.min.js?cbust=1`, e.onload = () => {
      t = !0, i();
    }, e.onerror = () => {
      r = null, c(new Error("Failed to load Brightcove script"));
    }, document.body.appendChild(e);
  })), r;
}
function l() {
  return t;
}
export {
  l as isScriptAlreadyLoaded,
  d as loadBrightcoveScript
};
//# sourceMappingURL=loadBrightcoveScript.mjs.map
